import React, { useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Table, Button, Label, Loader, Popup, Icon } from 'semantic-ui-react';
import ModalConfirm from '../../../../components/modals/ModalConfirm'
import { sharedAccessService } from "../../../../store/services/ServiceSharedAccess";
import { toast } from '../../../../components/others/ToastContainer';
import { useDispatch, useSelector } from 'react-redux';
import { addUser } from '../../../../store/actions';
import { routes } from '../../../../store/routes';
const StatusLabel = ({ status, statuses }) => {
    const statusInfo = statuses.find(s => s.status === status) || {};
    return (
        <Label size="tiny" color={statusInfo.color}>
            <Icon name={statusInfo.icon} />
            {statusInfo.label}
        </Label>
    );
};

const MessagePopup = ({ content }) => {
    if (!content) return '-';

    return (
        <Popup
            basic
            content={content}
            trigger={
                <span style={{ cursor: 'pointer' }}>
                    <Icon name="envelope" />
                </span>
            }
        />
    );
};

const SharedAccessTable = ({ activeFilter, requests, loading, onRelease, statuses }) => {
    const history = useHistory();
    const [openConfirm, setOpenConfirm] = useState(null);
    const [processing, setProcessing] = useState(null);

    const dispatch = useDispatch();
    const user = useSelector(state => state?.user?.original_admin || state?.user);

    const handleStartActingAs = async (providerId) => {
        setProcessing(providerId);
        document.querySelector('.dashboard-overlay').style.display = 'flex';
        await new Promise(resolve => setTimeout(resolve, 1000));

        // fetch provider data
        const request = await sharedAccessService.getProviderData(providerId);
        if (request.status === 200) {
            dispatch(addUser({
                ...user,
                id: request.response.id,
                email: request.response.email,
                role: request.response.role,
                is_coach: request.response.is_coach,
                is_town: request.response.is_town,
                original_admin: user,
            }));

            history.push(routes.DASHBOARD + "profile");

            toast({
                type: 'success',
                message: 'Úspešne ste sa prihlásili ako zadávateľ: ' + request.response.email
            });
        } else {
            toast({
                type: 'error',
                message: 'Nepodarilo sa prihlásiť na zadávateľa: ' + request.response.email
            });
        }
        setProcessing(null);
        document.querySelector('.dashboard-overlay').style.display = 'none';
    };

    const formatDate = (date) => {
        return date ? moment(date).format('DD.MM.YYYY HH:mm') : '-';
    };

    if (loading) {
        return (
            <div style={{ padding: '2rem', textAlign: 'center' }}>
                <Loader active inline>Načítavam údaje</Loader>
            </div>
        );
    }

    if (requests.length === 0) {
        return (
            <div style={{
                padding: '2rem',
                textAlign: 'center',
                color: 'rgba(0,0,0,0.5)'
            }}>
                <Icon name="info circle" size="large" />
                <p style={{ marginTop: '0.5rem' }}>Žiadne žiadosti na zobrazenie</p>
            </div>
        );
    }

    return (
        <Table compact>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Zadávateľ</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>Správa</Table.HeaderCell>
                    <Table.HeaderCell>Odpoveď</Table.HeaderCell>
                    <Table.HeaderCell>Dátum žiadosti</Table.HeaderCell>
                    <Table.HeaderCell>Dátum odpovede</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell textAlign="right">Akcie</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {requests.map(request => (
                    <Table.Row key={request.id}>
                        <Table.Cell>{request.provider_name}</Table.Cell>
                        <Table.Cell>{request.provider_email}</Table.Cell>
                        <Table.Cell>
                            <MessagePopup content={request.message} />
                        </Table.Cell>
                        <Table.Cell>
                            <MessagePopup content={request.response_message} />
                        </Table.Cell>
                        <Table.Cell>{formatDate(request.created_at)}</Table.Cell>
                        <Table.Cell>{request.status !== 'pending' ? formatDate(request.response_date) : '-'}</Table.Cell>
                        <Table.Cell>
                            <StatusLabel status={request.status} statuses={statuses} />
                        </Table.Cell>
                        <Table.Cell textAlign="right">
                            {(request.status === 'pending' || request.status === 'approved') && (
                                <>
                                    {request.status === 'approved' && (
                                        <Button
                                            color="black"
                                            size="tiny"
                                            icon="sign in"
                                            title="Spravovať"
                                            disabled={processing === request.provider}
                                            loading={processing === request.provider}
                                            onClick={() => handleStartActingAs(request.provider)}
                                            content="Spravovať"
                                        />
                                    )}
                                    {request.status === 'approved' && (
                                        <Button
                                            basic
                                            size="tiny"
                                            negative
                                            disabled={processing === request.provider}
                                            title="Odobrať prístup"
                                            onClick={() => setOpenConfirm(request.id)}
                                            content="Odobrať prístup"
                                        />
                                    )}

                                    <ModalConfirm
                                        open={openConfirm === request.id}
                                        header="Potvrdenie"
                                        content="Chcete odobrať prístup k účtu zadávateľa?"
                                        confirmButton="Odobrať prístup"
                                        cancelButton="Zrušiť"
                                        onCancel={() => setOpenConfirm(null)}
                                        onConfirm={() => {
                                            onRelease(request.id);
                                            setOpenConfirm(null);
                                        }}
                                    />
                                </>
                            )}
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

export default SharedAccessTable;
